export const SharedTypes = Object.freeze({
    SHARED: 'Shared',
    COMPANY: 'Company',
});

export const ValidationRules = Object.freeze({
    IS_NUMERIC: 'isNumeric',
    MINIMUM_VALUE: 'minimumValue',
    MAXIMUM_VALUE: 'maximumValue',
    MAXIMUM_LENGTH: 'lengthMax',
    MINIMUM_LENGTH: 'lengthMin',
});

export const AttributeInputTypes = Object.freeze({
    HEADING: 'Heading',
    SUB_HEADING: 'Sub Heading',
    STATIC_TEXT: 'Free Text',
    INPUT_TEXT: 'Input Text',
    NUMBER: 'Number',
    LONG_INPUT_TEXT: 'Long Text',
    DATE: 'Date',
    DROP_DOWN: 'Dropdown',
    MULTI_DROP_DOWN: 'Multi Select',
    RADIO: 'Radiobutton',
    CHECKBOX: 'Checkbox',
    DURATION: 'Duration',
});

export const UserProfileTypes = Object.freeze({
    NORMAL: 'normal',
    USER_PROFILE: 'user_profile',
    BOTH: 'both',
});

export const AttributePropertyTypes = Object.freeze({
    NORMAL: 'normal',
    TAGGED: 'tagged',
});

export const AttributeSubmissionTypes = Object.freeze({
    TAGGED: 'tagged',
    COMPANY: 'company',
    SHARED: 'shared',
});

export const AttributeIcons = Object.freeze({
    ICON_1: 'pi-align-center',
    ICON_2: 'pi-align-justify',
    ICON_3: 'pi-align-left',
    ICON_4: 'pi-align-right',
    ICON_5: 'pi-amazon',
    ICON_6: 'pi-bars',
    ICON_7: 'pi-angle-double-down',
    ICON_8: 'pi-angle-double-left',
    ICON_9: 'pi-angle-double-right',
    ICON_10: 'pi-angle-double-up',
    ICON_11: 'pi-angle-down',
    ICON_12: 'pi-angle-up',
    ICON_13: 'pi-angle-left',
    ICON_14: 'pi-angle-right',
    ICON_15: 'pi-arrow-circle-down',
    ICON_16: 'pi-arrow-circle-up',
    ICON_17: 'pi-arrow-circle-left',
    ICON_18: 'pi-arrow-circle-right',
    ICON_19: 'pi-arrow-down',
    ICON_20: 'pi-arrow-up',
    ICON_21: 'pi-arrow-left',
    ICON_22: 'pi-arrow-right',
    ICON_23: 'pi-briefcase',
    ICON_24: 'pi-arrow-down-left',
    ICON_25: 'pi-arrow-down-right',
    ICON_26: 'pi-arrow-up-left',
    ICON_27: 'pi-arrow-up-right',
    ICON_28: 'pi-building',
    ICON_29: 'pi-arrows-h',
    ICON_30: 'pi-arrows-v',
    ICON_31: 'pi-at',
    ICON_32: 'pi-backward',
    ICON_33: 'pi-forward',
});

export const FormulaTypes = Object.freeze({
    BOOLEAN: 'boolean',
    VALUE: 'value',
});

export const UserPermissions = Object.freeze({
    READ_MFA: 'read_mfa',
    WRITE_MFA: 'write_mfa',
    // Assessment attribute category
    READ_ASSESSMENT_ATTRIBUTE_CATEGORY: 'read_assessment_attribute_category',
    WRITE_ASSESSMENT_ATTRIBUTE_CATEGORY: 'write_assessment_attribute_category',
    DELETE_ASSESSMENT_ATTRIBUTE_CATEGORY: 'delete_assessment_attribute_category',
    // Tag and Rule
    READ_ASSESSMENT_ATTRIBUTE_TAG: 'read_assessment_attribute_tag',
    READ_ASSESSMENT_ATTRIBUTE_RULE: 'read_assessment_attribute_rule',
    // Attributes
    READ_ASSESSMENT_ATTRIBUTES: 'read_assessment_attributes',
    WRITE_ASSESSMENT_ATTRIBUTES: 'write_assessment_attributes',
    DELETE_ASSESSMENT_ATTRIBUTES: 'delete_assessment_attributes',
    // User Profile Attributes
    READ_USER_PROFILE_ATTRIBUTES: 'read_user_profile_attributes',
    WRITE_USER_PROFILE_ATTRIBUTES: 'write_user_profile_attributes',
    DELETE_USER_PROFILE_ATTRIBUTES: 'delete_user_profile_attributes',

    // Blocks
    READ_ASSESSMENT_BLOCKS: 'read_assessment_blocks',
    WRITE_ASSESSMENT_BLOCKS: 'write_assessment_blocks',
    DELETE_ASSESSMENT_BLOCKS: 'delete_assessment_blocks',
    // Assessment category
    READ_ASSESSMENT_CATEGORY: 'read_assessment_category',
    WRITE_ASSESSMENT_CATEGORY: 'write_assessment_category',
    DELETE_ASSESSMENT_CATEGORY: 'delete_assessment_category',
    // Assessments
    READ_ASSESSMENT: 'read_assessment',
    WRITE_ASSESSMENT: 'write_assessment',
    DELETE_ASSESSMENT: 'delete_assessment',
    // Assessment forms
    READ_ASSESSMENT_FORM: 'read_assessment_form',
    WRITE_ASSESSMENT_FORM: 'write_assessment_form',
    DELETE_ASSESSMENT_FORM: 'delete_assessment_form',
    // Share Exercise
    SHARE_EXERCISE: 'share_exercise',
    // Assessments result template
    READ_ASSESSMENT_RESULT_TEMPLATE: 'read_assessment_result_template',
    WRITE_ASSESSMENT_RESULT_TEMPLATE: 'write_assessment_result_template',
    DELETE_ASSESSMENT_RESULT_TEMPLATE: 'delete_assessment_result_template',
    // Formulas
    READ_FORMULAS: 'read_formulas',
    WRITE_FORMULAS: 'write_formulas',
    DELETE_FORMULAS: 'delete_formulas',

    // User Groups
    READ_USER_GROUP: 'read_user_group',
    WRITE_USER_GROUP: 'write_user_group',
    DELETE_USER_GROUP: 'delete_user_group',
    // Report Metrics
    READ_METRIC: 'read_metric',
    WRITE_METRIC: 'write_metric',
    DELETE_METRIC: 'delete_metric',
    // Users information
    READ_USERS: 'read_users',
    WRITE_USERS: 'write_users',

    READ_PERMISSIONS: 'read_permissions',
    READ_GROUPS: 'read_groups',
    WRITE_GROUPS: 'write_groups',
    DELETE_GROUPS: 'delete_groups',

    READ_DATASOURCE: 'read_datasource',
    WRITE_DATASOURCE: 'write_datasource',
    DELETE_DATASOURCE: 'delete_datasource',

    READ_COMPANY: 'read_company',
    WRITE_COMPANY: 'write_company',
    DELETE_COMPANY: 'delete_company',

    HMI_REPORT_INSIGHT_PORTFOLIO: 'report_insight_portfolio',
    ALLOW_ARCHIVE_USER: 'allow_archive_user',
});

export const ContainerTypes = Object.freeze({
    COVER_1: 'cover1',
    COVER_2: 'cover2',
    COVER_3: 'cover3',
    COVER_4: 'cover4',
    MAIN: 'main',
    CONTAINER: 'container',
    IMAGE: 'image',
    GRAPH: 'graph',
    UL: 'ul',
    OL: 'ol',
    TEXT: 'text',
    PAGE_BREAK: 'page_break',
    // add sub containers here later
});

export const ContainerLayouts = Object.freeze({
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
});

export const VerticalAlignments = Object.freeze({
    TOP: 'top',
    BOTTOM: 'bottom',
});

export const HorizontalAlignments = Object.freeze({
    LEFT: 'left',
    RIGHT: 'right',
});
